<div id="navigation">
    <div class="hamburger hamburger--slider float-left">
        <div class="hamburger-box">
            <div class="hamburger-inner"></div>
        </div>
    </div>
    
    <div class="mobile-menu montserrat">
        <a routerLink="/" class="list-group-item list-group-item-action" routerLinkActive="router-link-active"><i class="fa fa-home" aria-hidden="true"></i> HOME</a>
        <a routerLink="/dieta-chetogenica" class="list-group-item list-group-item-action" routerLinkActive="router-link-active">DIETA CHETOGENICA</a>

        <a routerLink="/protocollo-chetogenico" class="list-group-item list-group-item-action" routerLinkActive="router-link-active">
            <span class="pl-3">PROTOCOLLO CHETOGENICO L-AMINO</span>
        </a>

        <a routerLink="/chi-sono" class="list-group-item list-group-item-action" routerLinkActive="router-link-active">CHI SONO</a>
        <a routerLink="/blog" class="list-group-item list-group-item-action" routerLinkActive="router-link-active">BLOG LA SCIENZA</a>
        <a routerLink="/approfondimenti" class="list-group-item list-group-item-action" routerLinkActive="router-link-active">APPROFONDIMENTI</a>
        <a href="http://amicideldoc.leonelifestyle.com/" target="_blank" class="list-group-item list-group-item-action" routerLinkActive="router-link-active">AMICI DEL DOC</a>
        <a routerLink="/partner" class="list-group-item list-group-item-action" routerLinkActive="router-link-active">PARTNER</a>

        <div class="list-group-item list-group-item-action inverted">
            <i class="fa fa-envelope" aria-hidden="true"></i>
            <span class="mx-2">
                <a href="mailto:commerciale@leonelifestyle.com">CONTATTI</a>
            </span>
        </div>
    
        <div class="list-group-item list-group-item-action inverted">
            <i class="fa fa-shopping-bag" aria-hidden="true"></i>
            <a href="https://shop.leonelifestyle.com" target="_blank">
                <span class="mx-2">VAI ALLO SHOP</span>
            </a>
        </div>
    </div>
    
    <section class="top-menu montserrat">
        <div class="content float-right px-3 pt-3">
    
            <i class="fa fa-envelope" aria-hidden="true"></i>
            <span class="mx-2">
                <a href="mailto:commerciale@leonelifestyle.com">commerciale@leonelifestyle.com</a>
            </span>
    
            <i class="fa fa-shopping-bag" aria-hidden="true"></i>
            <a href="https://shop.leonelifestyle.com" target="_blank">
                <span class="mx-2">VAI ALLO SHOP</span>
            </a>
        </div>
    </section>
    
    <section class="menu montserrat">
        <div class="wrapper marginauto">

            <div class="col-xl-5 col-lg-5 col-md-5 float-left pt-3" style="position: relative; z-index:99999">
                <ul class="nav">

                    <li class="first col-4 text-center">
                        <a routerLink="/dieta-chetogenica" routerLinkActive="router-link-active">
                            DIETA <span class="d-xl-inline d-lg-inline d-md-none d-sm-none d-none">CHETOGENICA</span> <i class="fa fa-caret-down" aria-hidden="true"></i>
                        </a>

                        <ul>
                            <li>
                                <a routerLink="/protocollo-chetogenico" routerLinkActive="router-link-active">
                                    PROTOCOLLO CHETOGENICO L-AMINO
                                </a>
                            </li>
                        </ul>
                    </li>

                    <li class="first col-4 text-center">
                        <a class="selected" routerLink="/chi-sono" routerLinkActive="router-link-active">
                            CHI SONO
                        </a>
                    </li>

                    <li class="first col-4 text-center">
                        <a class="selected" routerLink="/blog" routerLinkActive="router-link-active">
                            BLOG <span class="d-xl-inline d-lg-inline d-md-none d-sm-none d-none">LA SCIENZA</span>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="logo-small-wrapper col-xl-2 col-lg-2 col-md-2 float-left">
                <div class="logo-small">
                    <a routerLink="/" routerLinkActive="router-link-active">
                        <img class="lazyload" data-src="./assets/logo-color.svg" alt="Leone Lifestyle" title="Leone Lifestyle">
                    </a>
                </div>
            </div>

            <div class="col-xl-5 col-lg-5 col-md-5 float-left pt-3" style="position: relative; z-index:99999">
                <ul class="nav">
                    <li class="first col-4 text-center">
                        <a routerLink="/approfondimenti" routerLinkActive="router-link-active">
                            APPROFONDIMENTI
                        </a>
                    </li>

                    <li class="first col-4 text-center">
                        <a href="http://amicideldoc.leonelifestyle.com/" target="_blank" routerLinkActive="router-link-active">
                            AMICI DEL DOC
                        </a>
                    </li>

                    <li class="first col-4 text-center">
                        <a routerLink="/partner" routerLinkActive="router-link-active">PARTNER</a>
                    </li>

                </ul>
            </div>
        </div>
    </section>
</div>